import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../common/SectionHeader';
import API from '../../utils/ApiConfig';
import { GET_GL_WRITEBACK_VERSIONS, WRITEBACK_TO_GL } from '../../utils/ApiEndpoints';
import ErrorMessage from '../common/ErrorMessage/ErrorMessage';
import ConfirmMessage from '../common/ConfirmMessage/ConfirmMessage';
import TooltipComponent from '../common/Tooltip/Tooltip';
import Loader from '../common/Loader/Loader';

const SuccessMessage = ErrorMessage;

const GLWriteBack = props => {
  const [writebackVersions, setWritebackVersions] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [planId, setPlanId] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showConfirmMessage, setShowConfirmMessage] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const { t } = useTranslation();
  const tc = (e, data) => (data ? t(`writeback:${e}`, data) : t(`writeback:${e}`));

  useEffect(() => {
    const {
      services: { PlanConnectionService },
    } = props;
    PlanConnectionService.planLoaded().then(function (planId) {
      setPlanId(planId);
      if (planId) {
        getGLWritebackVersions(planId);
        setLoading(true);
      }
    });
  }, []);

  const getGLWritebackVersions = planId => {
    API.get(GET_GL_WRITEBACK_VERSIONS(planId))
      .then(data => {
        data.data && setWritebackVersions(data.data);
      })
      .catch(err => {
        err && err.response && err.response.data && setErrorMessage(err.response.data.status);
        setShowErrorMessage(true);
      })
      .finally(() => setLoading(false));
  };

  const handleChange = event => setSelectedValue(event.target.value);

  const handleWriteBackToGL = () => {
    setShowConfirmMessage(true);
  };

  const onWritebackConfirm = () => {
    setLoading(true);
    API.post(WRITEBACK_TO_GL, {
      planId: planId,
      versionMemberId: selectedValue,
    })
      .then(() => {
        setSelectedValue('');
        getGLWritebackVersions(planId);
        setShowSuccessMessage(true);
      })
      .catch(err => {
        err && err.response && err.response.data && setErrorMessage(err.response.data.status);
        setShowErrorMessage(true);
      })
      .finally(() => setLoading(false));
  };

  const closeErrorMessage = () => setShowErrorMessage(false);

  const closeSuccessMessage = () => setShowSuccessMessage(false);

  const closeConfirmMessage = () => setShowConfirmMessage(false);

  const handleWritebackSuccessMsg = () => {
    return (
      <Fragment>
        <div style={{ fontSize: '18px' }}>{tc('SUCCESS_MSG')}</div>
        <ul style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li>{tc('SUCCESS_MSG_LIST_1')}</li>
          <li>{tc('SUCCESS_MSG_LIST_2')}</li>
        </ul>
      </Fragment>
    );
  };

  const handleVersionMembersTooltip = () => {
    return (
      <Fragment>
        <div>{tc('VERSION_MEMBERS_TOOLTIP_DESC')}</div>
        <ul style={{ paddingLeft: '20px', marginTop: '15px' }}>
          <li>{tc('VERSION_MEMBERS_TOOLTIP_LIST_1')}</li>
          <li>{tc('VERSION_MEMBERS_TOOLTIP_LIST_2')}</li>
        </ul>
      </Fragment>
    );
  };

  const handleWritebackConfirmMsg = () => {
    return (
      <Fragment>
        <div style={{ margin: '15px 0' }}>{tc('WRITE_BACK_CONFIRM')}</div>
        <p>{tc('WRITE_BACK_CONFIRM_DESC')}</p>
      </Fragment>
    );
  };

  return (
    <div className="GlWBContainer">
      {isLoading ? <Loader /> : ''}
      <SectionHeader title={tc('BUDGET_WRITE_BACK')} icon="icon-budget_write_back" />

      <div className="GlWBFormContainer">
        <div className="formControl">
          <label className="GlWBLabel"> {tc('WRITE_BACK_VERSION')}: </label>

          <select className="GlWBSelect" value={selectedValue} onChange={handleChange}>
            <option value="" style={{ display: 'none' }} disabled>
              {tc('SELECT_VERSION_MEMBER')}
            </option>
            {writebackVersions.length &&
              writebackVersions.map((item, index) => (
                <option value={item.id} key={item.id}>
                  {item.name}
                </option>
              ))}
          </select>
          <TooltipComponent title={writebackVersions.length ? handleVersionMembersTooltip() : tc('VERSION_MEMBERS_EMPTY_TOOLTIP_DESC')}>
            <span className="badge warning-color mouse-pointer">?</span>
          </TooltipComponent>
        </div>
        <div className="GlWButtonContainer">
          <button className="btn btn-primary btn-confirm" onClick={handleWriteBackToGL} disabled={!selectedValue.length}>
            {tc('WRITE_BACK_GL')}
          </button>
        </div>
      </div>
      <ErrorMessage open={showErrorMessage} handleClose={closeErrorMessage} message={errorMessage} />
      <ConfirmMessage
        open={showConfirmMessage}
        message={handleWritebackConfirmMsg()}
        onConfirm={onWritebackConfirm}
        handleClose={closeConfirmMessage}
        confirmText={tc('CONFIRM_BTN')}
        cancelText={tc('CANCEL_CONFIRM_BTN')}
      />
      <SuccessMessage open={showSuccessMessage} handleClose={closeSuccessMessage} message={handleWritebackSuccessMsg()} />
    </div>
  );
};

export default GLWriteBack;